import { faSpinner } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const FullPageLoading = () => {
  return (
    <div className="flex w-full h-screen justify-center items-center content-center">
      <FontAwesomeIcon icon={faSpinner} spin size="2xl" />
    </div>
  );
};
export default FullPageLoading;
